import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography, useTheme } from '@mui/material';

interface Props {
    label: string;
    onClear(): void;
}

export default function FilterChip({ label, onClear }: Props) {
    const theme = useTheme();
    return (
        <Box
            sx={{
                fontWeight: '600',
                backgroundColor: theme.palette.primary.P_50,
                padding: '6px 4px 6px 10px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                borderRadius: '4px',
            }}
        >
            <Typography variant="h4" sx={{ lineHeight: '18px' }}>
                {label}
            </Typography>
            <IconButton onClick={onClear} sx={{ color: '#16171A' }} size="small">
                <CloseIcon fontSize="small" />
            </IconButton>
        </Box>
    );
}
